module.exports = __webpack_public_path__ + "static/media/icons8-casa.00a751d7.svg";